import jQuery from 'jquery';

jQuery((
  $: JQueryStatic
) => {
  const screen = $(window);
  const animator = $('<div></div>');

  $('a[href^="#"]').on('click', (event) => {
    event.preventDefault();

    const pos = screen.scrollTop() ?? 0;
    const href = $(event.currentTarget).attr('href');
    const target = href && $(href).offset()?.top || 0;
    const step = (target - pos) / 100;
    animator
      .stop(true, false)
      .css({height: 0})
      .animate({height: 100}, {
        duration: 300,
        step: (progress) => {
          screen.scrollTop(pos + step * progress);
        }
      });
  });

  screen
    .on('scroll.top', () => {
      const offset = screen.scrollTop() ?? 0;
      const link = $('a.top');
      const height = link.outerHeight() ?? 0;
      link.css({bottom: offset > 100 ? 0 : -height});
    });
  // x.trigger('scroll.top');
});
